import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ukCommon from "@/locales/uk/common.json";
import deCommon from "@/locales/de/common.json";

const storedLang = typeof window !== "undefined" ? localStorage.getItem("lang") : null;
const urlLang =
  typeof window !== "undefined"
    ? new URLSearchParams(window.location.search).get("lang")
    : null;

void i18n.use(initReactI18next).init({
  lng: urlLang ?? storedLang ?? "uk",
  fallbackLng: "uk",
  supportedLngs: ["uk", "de"],
  ns: ["common"],
  defaultNS: "common",
  resources: {
    uk: { common: ukCommon },
    de: { common: deCommon },
  },
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

/**
 * Lazy-load additional namespaces on demand (M14). Currently all strings live
 * in the bundled <code>common</code> namespace.
 */
export async function ensureNamespace(ns: string | string[]) {
  await i18n.loadNamespaces(ns);
}

export function setLocale(lang: "uk" | "de") {
  void i18n.changeLanguage(lang);
  localStorage.setItem("lang", lang);
  document.cookie = `lang=${lang}; path=/; max-age=${60 * 60 * 24 * 365}`;
}

export default i18n;
